/**
 * @since 2023-04-05
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import PanelHeader from "components/Shared/PanelHeader";
import ToggleButtonGroupResearch from "components/Shared/ToggleButtonGroupResearch";
import { RiLineChartFill } from "react-icons/ri";
import { Navigate, Outlet, Route, Routes, useNavigate } from "react-router-dom";
import PanelAnalysis from "./PanelAnalysis";
import PanelReports from "./PanelReports";
import PanelScores from "./PanelScores";
import PanelSettings from "./PanelSettings";

const StrategyBuilder = ({
  email,
  menuItem,
  listStrategyNames,
  listStrategyFrequencies,
  listLockedIds,
  configuration,
  onStrategyNameChange,
  isNavBarVisible,
}) => {
  const navigate = useNavigate();

  const goToAnalysisView = () => {
    navigate("analysis", { relative: true });
  };

  const goToReportsView = () => {
    navigate("reports", { relative: true });
  };

  const goToScoresView = () => {
    navigate("scores", { relative: true });
  };

  return (
    <>
      {menuItem && (
        <>
          <PanelHeader
            menuItem={menuItem}
            icon={<RiLineChartFill style={{ fontSize: "30px" }} />}
            toggleButtonGroup={
              <ToggleButtonGroupResearch
                selectedValue={menuItem.ItemView}
                strategyType="customized strategy"
              />
            }
            isNavBarVisible={isNavBarVisible}
          />
          <Routes>
            <Route element={<Outlet />}>
              <Route
                path={"settings"}
                element={
                  <PanelSettings
                    email={email}
                    strategyId={menuItem.ItemId}
                    isLocked={listLockedIds.includes(menuItem.ItemId)}
                    listStrategyNames={listStrategyNames}
                    listStrategyFrequencies={listStrategyFrequencies}
                    configuration={configuration}
                    onStrategyNameChange={onStrategyNameChange}
                    onAnalysisClick={goToAnalysisView}
                  />
                }
              />
              <Route
                path={"analysis"}
                element={
                  <PanelAnalysis
                    email={email}
                    strategyId={menuItem.ItemId}
                    strategyName={menuItem.ItemName}
                    onScoresClick={goToScoresView}
                  />
                }
              />
              <Route
                path={"reports"}
                element={
                  <PanelReports email={email} strategyId={menuItem.ItemId} />
                }
              />
              <Route
                path={"scores"}
                element={
                  <PanelScores
                    email={email}
                    strategyId={menuItem.ItemId}
                    onReportsClick={goToReportsView}
                  />
                }
              />
              <Route path="*" element={<Navigate to="settings" />} />
            </Route>
          </Routes>
        </>
      )}
    </>
  );
};
export default StrategyBuilder;
